export default "__VITE_ASSET__95503a9f__"